/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonSearchHandlerInfo = {
    ID: BabylonSearchHandlerInfo.ID;
    SRLIST: Record<string, any>;
};

export namespace BabylonSearchHandlerInfo {

    export enum ID {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        FINALITY_PROVIDER = 'FINALITY_PROVIDER',
        ACCOUNT = 'ACCOUNT',
        VALIDATOR = 'VALIDATOR',
        TOKEN = 'TOKEN',
        CONTRACT = 'CONTRACT',
        RELAYER = 'RELAYER',
        COVENANT_COMMITTEE = 'COVENANT_COMMITTEE',
    }


}

